import { SupportedPlatforms } from '@/api/rankingExplainer.types';
import { RankingSnapshotPlatformLabel } from '@/services/tracking/GtmTrackingService';

const PLATFORM_TO_TRACKING_LABEL: Record<SupportedPlatforms, RankingSnapshotPlatformLabel> = {
  [SupportedPlatforms.HOMEGATE]: RankingSnapshotPlatformLabel.HOMEGATE,
  [SupportedPlatforms.IMMOSCOUT24]: RankingSnapshotPlatformLabel.IMMOSCOUT,
};

export function mapRankingSnapshotPlatformToTrackingLabel(
  platform: SupportedPlatforms,
): RankingSnapshotPlatformLabel {
  return PLATFORM_TO_TRACKING_LABEL[platform];
}
